import { styled } from '@compiled/react';
import { withAnalyticsContext, withAnalyticsEvents, createAndFireEvent } from '@atlaskit/analytics-next';
import { DropdownItem } from '@atlaskit/dropdown-menu';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const NoUnderlineDropdownItem = styled(DropdownItem)({
    textDecoration: 'none',
    '&:focus, &:hover, &:visited, &:link, &:active': {
        textDecoration: 'none',
    },
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const NoUnderlineDropdownItemWithAnalytics = withAnalyticsContext({
    componentName: 'dropdownItem',
})(
    withAnalyticsEvents({
        onClick: createAndFireEvent('atlaskit')({
            action: 'clicked',
            actionSubject: 'dropdownItem',
        }),
    })(NoUnderlineDropdownItem)
);
